import React from "react";
import { Link } from "react-router-dom";
import { styles } from "./style";
// import s from "./findhotspot.module.css";
import globalContext from "../../context/globalContext";
import {
  Card,
  Button,
  CircularProgress,
  Dialog,
  Tabs,
  Tab,
  ListItem,
  List,
  Divider,
  TextField,
  Typography,
  InputAdornment
} from "@material-ui/core";
import {
  LocationOn,
  AccessTime,
  Info,
  ArrowRight,
  CloseRounded,
  Search,
  Close,
} from "@material-ui/icons";
import moment from "moment";
import { withStyles, withTheme } from "@material-ui/core";
import s from "./style.module.css";
// import label from '../../framework/whiteLabel'
import { withRouter } from "react-router";
import config from "../../configuration/config";
// import { halfWidth } from 'validator/lib/isHalfWidth'
// import PropTypes from "prop-types";
import _ from "lodash";
import { isAlpha } from "validator";
import NewUserDeliveryLocationDialog from "../NewUserDeliveryLocationDialog";

//MAPBOX
const mbxGeocoding = require("@mapbox/mapbox-sdk/services/geocoding");
const geocodingClient = mbxGeocoding({ accessToken: config.mapbox.key });


class FindHotspotZip extends React.Component {
  static contextType = globalContext;
  constructor(props) {
    super(props);

    this.state = {
      zip: props.match.params.zip,
      error: false,
      errorText: "",
      loading: false,
      hotspot: { coordinatesForZip: null, popUpLocations: [] },
      zoom: [13],
      mapIsMoving: false,
      showLocationLabels: false,
      coordinates: { lng: null, lat: null },
      popUpLocations: [],
      puliDelivery: null,
      isOriginalSearch: true,
      dialogOpen: false,
      tabValue: 0,
      mapboxNewLocationDialogOpen: false,
      searchCustomerLocationInput: "",

      suggestionList: null,

      mapboxSelectedLocation: null,
      address2: "",
      creatingUserLocation: false,

      userLocation: null,
      userLocationAttempted: false
    };
  }

  async componentWillMount() {
    this.setState({ loading: true });
    let h = await this.context.global.findHotSpot(this.state.zip);
    this.createStateDataFromZip(h);
  }

  createStateDataFromZip = h => {
    for (let i = 0; i < h.popUpLocations.length; i++) {
      const distance = Math.sqrt(
        Math.pow(
          Math.abs(h.popUpLocations[i].latitude - h.coordinatesForZip.lat),
          2
        ) +
          Math.pow(
            Math.abs(h.popUpLocations[i].longitude - h.coordinatesForZip.lng),
            2
          )
      );
      h.popUpLocations[i].distanceAway = distance;
    }
    h.popUpLocations.sort(function(a, b) {
      return a.distanceAway - b.distanceAway;
    });
    h.puliDelivery.sort(function(a, b) {
      return a.pickupTimestampStart - b.pickupTimestampStart;
    });

    let tab = 0;
    if (h.popUpLocations.length === 0) {
      tab = 1;
    }

    this.setState({
      hotspots: h,
      loading: false,
      popUpLocations: h.popUpLocations,
      coordinates: {
        lng: h.coordinatesForZip.lng,
        lat: h.coordinatesForZip.lat
      },
      puliDelivery: h.puliDelivery,
      tabValue: tab
    });
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    this.context.global.setGlobalState("covidDialog", true)
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value,
      userUpToDate: false
    });
  };

  handleSearchMapBoxChange = async event => {
    this.setState({ [event.target.id]: event.target.value });
    await geocodingClient
      .forwardGeocode({
        query: event.target.value,
        countries: ["US"],
        limit: 5
      })
      .send()
      .then(response => {
        let displayLocations = [];
        for (let i in response.body.features) {
          let location = response.body.features[i];
          let formattedLocation = {};
          let customerLocation = {};
          if (location.place_type.includes("address")) {
            let splitAddressArray = location.place_name.split(",");
            formattedLocation.address1 = splitAddressArray[0];
            formattedLocation.city = splitAddressArray[1];
            formattedLocation.state = abbrRegion(
              splitAddressArray[2].slice(1, -6),
              "TO_ABBREVIATED"
            );
            formattedLocation.zip = splitAddressArray[2].substr(-5);
            location.displayAddress = formattedLocation;
            customerLocation = { ...location };
            displayLocations.push(customerLocation);
          }
        }
        this.setState({ suggestionList: displayLocations });
      });

    // window.scrollTo(0, document.body.scrollHeight)
  };

  handleFindClosestHotspot() {
    const { popUpLocations, coordinates } = this.state;

    if (popUpLocations.length !== 0) {
      for (let i = 0; i < popUpLocations.length; i++) {
        const distance = Math.sqrt(
          Math.pow(Math.abs(popUpLocations[i].latitude - coordinates.lat), 2) +
            Math.pow(Math.abs(popUpLocations[i].longitude - coordinates.lng), 2)
        );
        popUpLocations[i].distanceAway = distance;
      }
      popUpLocations.sort(function(a, b) {
        return a.distanceAway - b.distanceAway;
      });
      this.setState({
        coordinates: {
          lng: popUpLocations[0].longitude,
          lat: popUpLocations[0].latitude
        },
        popUpLocations
      });
      this.setState({ zoom: [16], isOriginalSearch: false });
    } else {
      this.context.global.setGlobalState(
        "errorSnackbarText",
        "No HotSpots, Please Check Back Later"
      );
      this.context.global.setGlobalState("errorSnackbarState", true);
    }
  }

  async selectPopUpInstance(puli) {
    // setHotSpotLoading(true);
    this.context.global.setGlobalState("accountDialogState", false);
    this.context.global.setGlobalState("appMenuDialogState", false);

    // await context.global.getCurrentShoppingCart();
    await this.context.global.selectPopUpLocationInstance(puli);
    // if (context.global.data.groupCategories.length > 0) {
    // context.global.clearGroupCategories();
    // await context.global.getGroupCategories(puli.uuid);
    // }
    // setHotSpotLoading(false);
    await this.context.global.getUserByUuid();

    this.props.history.replace("/dashboard");
  }

  handleTabChange = async (event, tabValue) => {
    const { userLocationAttempted, userLocation } = this.state;
    if (tabValue === 1 && userLocationAttempted && !userLocation) {
      this.setState({ tabValue, mapboxNewLocationDialogOpen: true });
    }
    this.setState({ tabValue });
  };

  setInitialUserLocation = user => {
    if (user.locations.length > 0) {
      let primary = user.locations.find(i => i.isPrimary === 1);
      if (primary) {
        this.setState({ userLocation: primary });
      } else {
        let location = _.head(
          user.locations.sort((a, b) => a.created - b.created)
        );
        this.setState({ userLocation: location });
      }
    } else {
      this.setState({ userLocationAttempted: true });
    }
  };

  handleSelectChange = name => event => {
    this.setState({ [name]: event.target.value });
  };

  createUserLocation = async () => {
    let { mapboxSelectedLocation, address2 } = this.state;
    mapboxSelectedLocation.address2 = address2;
    this.setState({ creatingUserLocation: true });
    let location = await this.context.global.createUserLocation(
      mapboxSelectedLocation
    );
    let h = await this.context.global.findHotSpot(location.zip);
    this.createStateDataFromZip(h);
    this.setState({
      creatingUserLocation: false,
      mapboxNewLocationDialogOpen: false,
      userLocation: location,
      mapboxSelectedLocation: null,
      searchCustomerLocationInput: "",
      suggestionList: null,
      address2: ""
    });
  };

  updateDeliveryLocaitons = async () => {
    const { user } = this.context.global.data;

    let userLocation;
    if (user && user.locations.length > 0) {
      let primary = user.locations.find(i => i.isPrimary === 1);
      if (primary) {
        userLocation = primary;
      } else {
        let location = _.head(
          user.locations.sort((a, b) => a.created - b.created)
        );
        userLocation = location;
      }
    }

    let h = await this.context.global.findHotSpot(userLocation.zip);
    this.createStateDataFromZip(h);
  };

  selectUserLocation = location => {
    let customerLocation = {};
    let formattedLocation = {};
    if (location.place_name) {
      let splitAddressArray = location.place_name.split(",");
      formattedLocation.address1 = splitAddressArray[0];
      formattedLocation.city = splitAddressArray[1];
      formattedLocation.state = abbrRegion(
        splitAddressArray[2].slice(1, -6),
        "TO_ABBREVIATED"
      );
      formattedLocation.zip = splitAddressArray[2].substr(-5);
      customerLocation = { ...location, ...formattedLocation };
      delete customerLocation.type;
    }

    customerLocation.mapboxId = location.id;

    if (location.latitude && location.longitude) {
      customerLocation.longitude = location.longitude;
      customerLocation.latitude = location.latitude;
    } else if (location.center && location.center.length > 1) {
      customerLocation.longitude = location.center[0];
      customerLocation.latitude = location.center[1];
    } else if (
      (!location.center || location.center.length < 1) &&
      location.geometry &&
      location.geometry.center
    ) {
      customerLocation.longitude = location.geometry.center[0];
      customerLocation.latitude = location.geometry.center[1];
    } else {
      return console.log("NO COORDINATE", location);
    }

    this.setState({ mapboxSelectedLocation: customerLocation });
  };

  render() {
    const { user } = this.context.global.data;
    const { classes, theme } = this.props;
    let {
      zip,
      loading,
      popUpLocations,
      puliDelivery,
      isOriginalSearch,
      selectedLocation,
      dialogOpen,
      tabValue,
      mapboxNewLocationDialogOpen,
      searchCustomerLocationInput,
      suggestionList,
      // userLocation,
      mapboxSelectedLocation,
      address2,
      creatingUserLocation
    } = this.state;
    if (loading) {
      return (
        <CircularProgress
          style={{ position: "fixed", zIndex: 9999, top: "50vh", left: "45vw" }}
        />
      );
    }

    // if (!userLocation && user && !userLocationAttempted) {
    //   this.setInitialUserLocation(user);
    // }

    let userLocation;
    if (user && user.locations.length > 0) {
      let primary = user.locations.find(i => i.isPrimary === 1);
      if (primary) {
        userLocation = primary;
      } else {
        let location = _.head(
          user.locations.sort((a, b) => a.created - b.created)
        );
        userLocation = location;
      }
    }

    return (
      <div className={s.container}>
        <Card className={classes.card}>
          <header className={classes.header}>
            <div className={s.findHotSpot_zip_header_text}>
              {isOriginalSearch ? `Tell us how!` : `Closest hotspot to ${zip}`}
            </div>
          </header>
          <div className={s.cardScrollControl}>
            <Tabs value={tabValue} onChange={this.handleTabChange} centered>
              <Tab label="Pickup" />
              <Tab label="Delivery" />
            </Tabs>
            <div className={s.mapButtonContainer}>
              {tabValue === 1 ? (
                <div className={s.customerDeliveryLocation}>
                  {userLocation ? (
                    <>
                      <Typography variant={"body1"} style={{ fontWeight: 700 }}>
                        Delivery To
                      </Typography>
                      <div className={s.customerDeliveryLocation_Address}>
                        <div
                          className={s.customerDeliveryLocation_Address_Left}
                        >
                          <LocationOn
                            style={{
                              color: theme.palette.primary.main,
                              fontSize: 45
                            }}
                          />
                        </div>
                        <div
                          className={s.customerDeliveryLocation_Address_Right}
                        >
                          <div className={s.dialogHeaderInstance}>
                            {userLocation.address1}
                          </div>
                          <div className={s.dialogHeaderInstance}>
                            {userLocation.address2}
                          </div>
                          <div className={s.dialogHeaderInstance}>
                            {userLocation.city} {userLocation.state}{" "}
                            {userLocation.zip}
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <Typography
                      style={{
                        padding: 40,
                        textAlign: "center",
                        fontWeight: 600
                      }}
                    >
                      Uh oh! Looks like you don't have an address of file.
                      Update Address below to see delivery times near you!
                    </Typography>
                  )}

                  <p
                    onClick={() => {
                      this.context.global.handleOpenNewUserDeliveryLocationDialog();
                    }}
                    style={{
                      textDecoration: "underline",
                      textAlign: "right",
                      fontFamily: "Montserrat",
                      fontSize: 12
                    }}
                  >
                    Update Address
                  </p>
                </div>
              ) : null}
            </div>
            <div className={s.mapContainer}>
              {userLocation && tabValue === 1 ? (
                <>
                  {!userLocation ? null : (
                    <>
                      {/* <Divider style={{margin: 10, width: '90%'}}/> */}
                      {!puliDelivery || puliDelivery.length < 1 ? (
                        <Typography
                          style={{
                            padding: 40,
                            textAlign: "center",
                            fontWeight: 600
                          }}
                        >
                          No Delivery times available for this address ... Check
                          back soon, we are expanding the service everyday!
                        </Typography>
                      ) : (
                        <>
                          <Typography
                            variant={"body1"}
                            style={{ fontWeight: 700 }}
                          >
                            Delivery Times
                          </Typography>
                          <List
                            className={classes.list + " " + s.deliveryTimesList}
                          >
                            {puliDelivery.map(l => {
                              // let nextHotspotTime;
                              // let nextHotspotDate;
                              if (
                                moment
                                  .unix(l.pickupTimestampStart)
                                  .isBefore(moment().add(1, "week"))
                              ) {
                                // nextHotspotTime = moment
                                //   .unix(l.pickupTimestampStart)
                                //   .format("dddd");
                                // nextHotspotDate = moment
                                //   .unix(l.pickupTimestampStart)
                                //   .format("M/D");
                              }
                              return (
                                <>
                                  <div
                                    key={l.uuid}
                                    className={
                                      l.maxOrdersReached
                                        ? s.dialogRowInstance_notAvailable
                                        : s.dialogRowInstance
                                    }
                                    onClick={
                                      l.maxOrdersReached
                                        ? null
                                        : () => {
                                            this.selectPopUpInstance(l);
                                          }
                                    }
                                  >
                                    <div className={s.dialogRowContainer}>
                                      <div className={s.dialogRowLeft}>
                                        <AccessTime
                                         style={
                                          l.maxOrdersReached
                                            ? {
                                                color: "#555"
                                              }
                                            : {
                                                color: theme.palette.primary.main
                                              }
                                        }
                                        />
                                      </div>
                                      <div className={s.dialogRowRight}>
                                        <div className={s.dialogHeaderInstance}>
                                          {moment(
                                            l.pickupTimestampStart * 1000
                                          ).format("dddd, h:mma")}{" "}
                                          -{" "}
                                          {moment(
                                            l.pickupTimestampEnd * 1000
                                          ).format("h:mma")}
                                        </div>
                                        <div className={s.dialogSubHeader}>
                                          {moment(
                                            l.pickupTimestampStart * 1000
                                          ).format("MMMM D, YYYY")}
                                        </div>

                                        {l.maxOrdersReached ? (
                                          <div
                                            style={{ color: "#000" }}
                                            className={s.dialogHeaderInstance}
                                          >
                                            No more available slots. Sorry for
                                            the inconvenience.
                                          </div>
                                        ) : (
                                          <>
                                            <div
                                              style={{
                                                color:
                                                  theme.palette.primary.main
                                              }}
                                              className={
                                                s.dialogHeaderInstanceSpecialInstructions
                                              }
                                            >
                                              Shopping ends{" "}
                                              {moment(
                                                (l.pickupTimestampStart -
                                                  l.bufferTime) *
                                                  1000
                                              ).format("M/D/YY @ h:mma")}
                                            </div>
                                            <div
                                              style={{
                                                color:
                                                  theme.palette.primary.main
                                              }}
                                              className={
                                                s.dialogHeaderInstanceSpecialInstructions
                                              }
                                            >
                                              {l.specialInstructions}
                                            </div>
                                          </>
                                        )}
                                      </div>
                                    </div>
                                    <div className={s.dialogRowButton}>
                                      <ArrowRight
                                        style={{ fontSizeLarge: 60 }}
                                        fontSize={"large"}
                                        color={l.maxOrdersReached ? "#000" : "primary"}
                                      />
                                    </div>
                                  </div>
                                </>
                              );
                            })}
                          </List>
                        </>
                      )}
                    </>
                  )}
                </>
              ) : null}
            </div>
            <div className={s.mapContainer}>
              {tabValue === 0 ? (
                <>
                  {!popUpLocations || popUpLocations.length < 1 ? (
                    <Typography
                      style={{
                        padding: 40,
                        textAlign: "center",
                        fontWeight: 600
                      }}
                    >
                      No Pickup times available for this zip code ... Check back
                      soon, we are expanding the service everyday!
                    </Typography>
                  ) : null}
                  <List className={classes.list}>
                    {popUpLocations.map(l => {
                      const { instances } = l;
                      let pickupTest = instances.find(
                        i => i.fulfillmentType === "PICKUP"
                      );
                      if (!pickupTest) {
                        return null;
                      }
                      instances.sort(
                        (a, b) =>
                          a.pickupTimestampStart - b.pickupTimestampStart
                      );
                      let nextHotspotTime;
                      let nextHotspotDate;
                      if (
                        moment
                          .unix(instances[0].pickupTimestampStart)
                          .isBefore(moment().add(1, "week"))
                      ) {
                        nextHotspotTime = moment
                          .unix(instances[0].pickupTimestampStart)
                          .format("dddd");
                        nextHotspotDate = moment
                          .unix(instances[0].pickupTimestampStart)
                          .format("M/D");
                      }
                      return (
                        <>
                          <ListItem
                            disableGutters
                            style={{ justifyContent: "spaceBetween" }}
                            onClick={() => {
                              this.setState({
                                dialogOpen: true,
                                selectedLocation: l
                              });
                              // setDialogOpen(true);
                              // setSelectedLocation(l);
                            }}
                          >
                            <div className={s.dialogRow} style={{ margin: 0 }}>
                              <div className={s.dialogRowContainer}>
                                <div className={s.dialogRowLeft}>
                                  <LocationOn
                                    style={{
                                      color: theme.palette.primary.main
                                    }}
                                  />
                                </div>
                                <div className={s.dialogRowRight}>
                                  <div className={s.dialogHeader}>{l.name}</div>
                                  <div className={s.dialogSubHeader}>
                                    <div>{l.address1}</div>
                                    <div>{l.address2}</div>
                                    <div>
                                      {l.city} {l.state} {l.zip}
                                    </div>
                                    <div
                                      style={{
                                        color: theme.palette.primary.main,
                                        fontSize: "1rem",
                                        paddingTop: 5,
                                        fontWeight: 600
                                      }}
                                    >
                                      {nextHotspotTime
                                        ? `${nextHotspotTime} Pickup (${nextHotspotDate})`
                                        : null}
                                    </div>
                                  </div>
                                </div>
                                <div className={s.dialogRowButton}>
                                  <ArrowRight
                                    style={{ fontSizeLarge: 60 }}
                                    fontSize={"large"}
                                    color={"primary"}
                                  />
                                </div>
                              </div>
                            </div>
                          </ListItem>
                          <Divider />
                        </>
                      );
                    })}
                  </List>
                  <footer>
                    <Link
                      to="/find-hot-spot"
                      style={{
                        textDecoration: "underline",
                        textAlign: "right",
                        fontFamily: "Montserrat",
                        fontSize: 12,
                        color: "inherit"
                      }}
                    >
                      Change Zip Code
                    </Link>
                  </footer>
                </>
              ) : null}
            </div>
          </div>
          <footer className={s.find_hot_spot_footer}>
            <div
              style={{
                display: "flex",
                alignItems: "baseline"
              }}
            >
              <p
                style={{
                  fontFamily: "Montserrat",
                  fontSize: 12
                }}
              >
                Looking for a
              </p>
              <Link
                to="/orders"
                style={{
                  marginLeft: 5,
                  textDecoration: "underline",
                  fontFamily: "Montserrat",
                  color: theme.palette.primary.main,
                  fontSize: 12
                }}
              >
                Previous Order?
              </Link>
            </div>
          </footer>
        </Card>
        {dialogOpen && selectedLocation ? (
          <Dialog
            fullScreen
            open={this.state.dialogOpen}
            onClose={() => this.setState({ dialogOpen: false })}
            // TransitionComponent={props => <Slide direction="up" {...props} />}
          >
            <div className={s.dialogContainer}>
              <div
                className={s.popUpImageContainer}
                style={{
                  backgroundImage: `url(${
                    selectedLocation ? selectedLocation.imageUrl : ""
                  })`
                }}
              >
                <div
                  className={s.dialogCloseContainer}
                  onClick={() => this.setState({ dialogOpen: false })}
                >
                  <CloseRounded
                    style={{
                      color: theme.palette.primary.main,
                      backgroundColor: "white",
                      boxShadow: "1px 1px 1px 1px #999",
                      borderRadius: 20
                    }}
                  />
                </div>
              </div>
              <div className={s.dialogContentContainer}>
                <div className={s.dialogRow}>
                  <div className={s.dialogRowContainer}>
                    <div className={s.dialogRowLeft}>
                      <LocationOn
                        style={{
                          color: theme.palette.primary.main
                        }}
                      />
                    </div>
                    <div className={s.dialogRowRight}>
                      <div className={s.dialogHeader}>
                        {selectedLocation.name}
                      </div>
                      <div className={s.dialogSubHeader}>
                        <div>{selectedLocation.address1}</div>
                        <div>{selectedLocation.address2}</div>
                        <div>
                          {selectedLocation.city} {selectedLocation.state}{" "}
                          {selectedLocation.zip}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={s.dialogRow}>
                  <div className={s.dialogRowContainer}>
                    <div className={s.dialogRowLeft}>
                      <Info
                        style={{
                          color: theme.palette.primary.main
                        }}
                      />
                    </div>
                    <div className={s.dialogRowRight}>
                      <div className={s.dialogHeader}>Special Instructions</div>
                      <div className={s.dialogSubHeader}>
                        {selectedLocation.specialInstructions}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                {/* <div style={{ padding: "0.5rem 2rem", fontWeight: 600 }}>
                Available Hotspot Options
              </div> */}
                {selectedLocation.instances.map(i => {
                  if (i.fulfillmentType === "DELIVERY") {
                    return null;
                  }

                  // BEATTY
                  // {i.maxOrdersReached ?  : }
                  return (
                    <div
                      key={i.uuid}
                      className={
                        i.maxOrdersReached
                          ? s.dialogRowInstance_notAvailable
                          : s.dialogRowInstance
                      }
                      onClick={
                        i.maxOrdersReached
                          ? null
                          : () => {
                              this.selectPopUpInstance(i);
                            }
                      }
                    >
                      <div className={s.dialogRowContainer}>
                        <div className={s.dialogRowLeft}>
                          <AccessTime
                            style={
                              i.maxOrdersReached
                                ? {
                                    color: "#000"
                                  }
                                : {
                                    color: theme.palette.primary.main
                                  }
                            }
                          />
                        </div>
                        <div className={s.dialogRowRight}>
                          <div className={s.dialogHeaderInstance}>
                            {moment(i.pickupTimestampStart * 1000).format(
                              "dddd, h:mma"
                            )}{" "}
                            -{" "}
                            {moment(i.pickupTimestampEnd * 1000).format(
                              "h:mma"
                            )}
                          </div>
                          <div className={s.dialogSubHeader}>
                            {moment(i.pickupTimestampStart * 1000).format(
                              "MMMM D, YYYY"
                            )}
                          </div>
                          {i.maxOrdersReached ? (
                            <div
                              style={{ color: "#000" }}
                              className={s.dialogHeaderInstance}
                            >
                              No more available slots. Sorry for the
                              inconvenience.
                            </div>
                          ) : (
                            <>
                              <div
                                style={{ color: theme.palette.primary.main }}
                                className={
                                  s.dialogHeaderInstanceSpecialInstructions
                                }
                              >
                                Shopping ends{" "}
                                {moment(
                                  (i.pickupTimestampStart - i.bufferTime) * 1000
                                ).format("M/D/YY @ h:mma")}
                              </div>
                              <div
                                style={{ color: theme.palette.primary.main }}
                                className={
                                  s.dialogHeaderInstanceSpecialInstructions
                                }
                              >
                                {i.specialInstructions}
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                      <div className={s.dialogRowButton}>
                        <ArrowRight
                          style={{ fontSizeLarge: 60 }}
                          fontSize={"large"}
                          color={i.maxOrdersReached ? "#000" : "primary"}
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </Dialog>
        ) : null}

        <NewUserDeliveryLocationDialog
          updateFunction={this.updateDeliveryLocaitons}
          noCheckShoppingCart
        />

        <Dialog
          fullWidth
          open={mapboxNewLocationDialogOpen}
          onClose={() => this.setState({ mapboxNewLocationDialogOpen: false })}
          // maxWidth={true}
        >
          <div className={s.findHotSpotZip_mapboxNewLocationDialog_outer}>
            {!mapboxSelectedLocation ? (
              <>
                <Typography>What address?</Typography>

                <TextField
                  multiline
                  autoFocus
                  fullWidth
                  id="searchCustomerLocationInput"
                  // label="delivery address"
                  value={searchCustomerLocationInput}
                  onChange={this.handleSearchMapBoxChange.bind(this)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment
                        onClick={() =>
                          this.setState({
                            searchCustomerLocationInput: "",
                            suggestionList: null
                          })
                        }
                        position="end"
                      >
                        <Close />
                      </InputAdornment>
                    )
                  }}
                />

                {suggestionList ? (
                  <>
                    <List>
                      {suggestionList.map(loc => {
                        return (
                          <>
                            <ListItem
                              className={classes.userLocationListItem}
                              Button
                              onClick={async () => {
                                await this.selectUserLocation(loc);
                                // await this.setState({
                                //   mapboxNewLocationDialogOpen: false
                                // })
                              }}
                            >
                              <LocationOn
                                style={{
                                  color: theme.palette.primary.main,
                                  paddingRight: 5
                                }}
                              />
                              <Typography variant={"body2"}>
                                {loc.displayAddress.address1}
                                <Typography variant={"caption"}>
                                  {loc.displayAddress.city} {" , "}{" "}
                                  {loc.displayAddress.state}
                                </Typography>
                              </Typography>
                            </ListItem>
                            <Divider />
                          </>
                        );
                      })}
                    </List>
                  </>
                ) : null}
              </>
            ) : null}
            {mapboxSelectedLocation ? (
              <div className={s.availability_customerNewLocationDialog_inner}>
                <div
                  className={s.availability_customerNewLocationDialog_inner_top}
                >
                  <Typography>Selected Address</Typography>

                  <div className={s.dialogRow}>
                    <div className={s.dialogRowContainer}>
                      <div className={s.dialogRowLeft}>
                        <LocationOn
                          style={{
                            color: theme.palette.primary.main
                          }}
                        />
                      </div>
                      <div className={s.dialogRowRight}>
                        {/* <div className={s.dialogHeader}>{userLocation && userLocation.place_name ? userLocation.place_name : (userLocation.name - userLocation.address1, userLocation.zip)}</div> */}
                        <div className={s.dialogSubHeader}>
                          <div>{mapboxSelectedLocation.address1}</div>
                          <div>{mapboxSelectedLocation.address2}</div>
                          <div>
                            {mapboxSelectedLocation.city}{" "}
                            {mapboxSelectedLocation.state}{" "}
                            {mapboxSelectedLocation.zip}
                          </div>
                        </div>
                      </div>
                      <p
                        onClick={() =>
                          this.setState({ mapboxSelectedLocation: null })
                        }
                        style={{
                          textDecoration: "underline",
                          textAlign: "right",
                          fontFamily: "Montserrat",
                          fontSize: 12
                        }}
                      >
                        Change
                      </p>
                    </div>
                  </div>

                  <div
                    className={s.dialogSubHeader}
                    style={{ textAlign: "center" }}
                  >
                    Is there anything your driver should know about this
                    address? Apartment number, gate or door code?
                  </div>

                  <TextField
                    multiline
                    autoFocus
                    fullWidth
                    id="address2"
                    helperText="(e.g. APT 123, Unit A, Passcode 1234)"
                    value={address2}
                    onChange={this.handleChange.bind(this)}
                  />
                </div>

                <Button
                  disabled={(() => {
                    if (creatingUserLocation) {
                      return true;
                    }
                  })()}
                  style={{ width: "100%", marginTop: 10 }}
                  onClick={async () => {
                    await this.createUserLocation();
                  }}
                >
                  {creatingUserLocation ? (
                    <CircularProgress style={{ height: 25, width: 25 }} />
                  ) : (
                    "Let's Go!"
                  )}
                </Button>
              </div>
            ) : null}
          </div>
        </Dialog>
      </div>
    );
  }
}

export default withTheme()(withStyles(styles)(withRouter(FindHotspotZip)));

function abbrRegion(input, to) {
  var states = [
    ["Alabama", "AL"],
    ["Alaska", "AK"],
    ["American Samoa", "AS"],
    ["Arizona", "AZ"],
    ["Arkansas", "AR"],
    ["Armed Forces Americas", "AA"],
    ["Armed Forces Europe", "AE"],
    ["Armed Forces Pacific", "AP"],
    ["California", "CA"],
    ["Colorado", "CO"],
    ["Connecticut", "CT"],
    ["Delaware", "DE"],
    ["District Of Columbia", "DC"],
    ["Florida", "FL"],
    ["Georgia", "GA"],
    ["Guam", "GU"],
    ["Hawaii", "HI"],
    ["Idaho", "ID"],
    ["Illinois", "IL"],
    ["Indiana", "IN"],
    ["Iowa", "IA"],
    ["Kansas", "KS"],
    ["Kentucky", "KY"],
    ["Louisiana", "LA"],
    ["Maine", "ME"],
    ["Marshall Islands", "MH"],
    ["Maryland", "MD"],
    ["Massachusetts", "MA"],
    ["Michigan", "MI"],
    ["Minnesota", "MN"],
    ["Mississippi", "MS"],
    ["Missouri", "MO"],
    ["Montana", "MT"],
    ["Nebraska", "NE"],
    ["Nevada", "NV"],
    ["New Hampshire", "NH"],
    ["New Jersey", "NJ"],
    ["New Mexico", "NM"],
    ["New York", "NY"],
    ["North Carolina", "NC"],
    ["North Dakota", "ND"],
    ["Northern Mariana Islands", "NP"],
    ["Ohio", "OH"],
    ["Oklahoma", "OK"],
    ["Oregon", "OR"],
    ["Pennsylvania", "PA"],
    ["Puerto Rico", "PR"],
    ["Rhode Island", "RI"],
    ["South Carolina", "SC"],
    ["South Dakota", "SD"],
    ["Tennessee", "TN"],
    ["Texas", "TX"],
    ["US Virgin Islands", "VI"],
    ["Utah", "UT"],
    ["Vermont", "VT"],
    ["Virginia", "VA"],
    ["Washington", "WA"],
    ["West Virginia", "WV"],
    ["Wisconsin", "WI"],
    ["Wyoming", "WY"]
  ];

  // So happy that Canada and the US have distinct abbreviations
  var provinces = [
    ["Alberta", "AB"],
    ["British Columbia", "BC"],
    ["Manitoba", "MB"],
    ["New Brunswick", "NB"],
    ["Newfoundland", "NF"],
    ["Northwest Territory", "NT"],
    ["Nova Scotia", "NS"],
    ["Nunavut", "NU"],
    ["Ontario", "ON"],
    ["Prince Edward Island", "PE"],
    ["Quebec", "QC"],
    ["Saskatchewan", "SK"],
    ["Yukon", "YT"]
  ];

  var regions = states.concat(provinces);

  var i; // Reusable loop variable
  if (to === "TO_ABBREVIATED") {
    if (isAlpha && input.length === 2) {
      return input;
    } else {
      input = input.replace(/\w\S*/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
      for (i = 0; i < regions.length; i++) {
        // eslint-disable-next-line eqeqeq
        if (regions[i][0] == input) {
          return regions[i][1];
        }
      }
    }
  } else if (to === "TO_NAME") {
    input = input.toUpperCase();
    for (i = 0; i < regions.length; i++) {
      // eslint-disable-next-line eqeqeq
      if (regions[i][1] == input) {
        return regions[i][0];
      }
    }
  }
}
